import { PricingCreateModule } from '@/components/modules/PricingCreate/PricingCreate';
import { APP_ROLES, APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

import { DYNAMIC_PAGE_PATHS } from '../../shared/pathRoutes';

export const PAGE_PRICING_CREATE: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.PRICING_CREATE,
  schemesByRoles: [
    {
      roles: [APP_ROLES.ADMIN, APP_ROLES.SUPER_ADMIN],
      titleTextId: 'CREATE_NEW_PRICING',
      widgets: [],
    },
  ],
  sections: [
    {
      textId: undefined,
      module: (
        <PricingCreateModule
          permissions={{
            view: [APP_USER_TYPES.SUPER_ADMIN, APP_USER_TYPES.ADMIN],
          }}
        />
      ),
    },
  ],
};
